module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_7.0041e34e.png";